import { useGetAllTabsDashboardData } from "@features/ax/dashboard/hooks";
import { ComplianceOverviewSection } from "./complianceOverview";
import { FacilityPerformanceSection } from "./facilityPerformance";
import { PrimaryStandardsSection } from "./primaryStandard";
import { ViolationsSamplingSection } from "./violationSampling";
import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";

const ComplianceQualityCard = () => {
  const { data: complianceData } = useGetAllTabsDashboardData("compliance");
  
  useEffect(() => {
    logEvent("Compliance Dashboard Viewed", {});
  }, []);

  return (
    <div className="space-y-6">
      <ComplianceOverviewSection data={complianceData} />
      <ViolationsSamplingSection data={complianceData} />
      <FacilityPerformanceSection data={complianceData} />
    </div>
  );
};

export default ComplianceQualityCard;